// Roles y Permisos: qué manda la matriz al guardar (RBAC-01, RBAC-03; Mario, 23-oct).
//
// La matriz la dibuja el catálogo del núcleo (GET /api/admin/rbac/matriz, de Reybier): cada acción trae su `code`
// real y cada submódulo su `moduleId`. Un código no siempre es de tres partes: `liquidacion.consultar` no tiene
// submódulo y `config.comercios.terms.read` tiene cuatro. Lógica pura: sin Angular, se prueba con node:test.

/** `('liquidacion', '', 'consultar')` → `liquidacion.consultar`; un submódulo vacío no deja un punto de más. */
export const armarCodigo = (module: string, submodule: string, action: string): string =>
  [module, submodule, action].filter(Boolean).join('.');

/** El código de una acción: el real que trae del catálogo y, si no lo trae, armado con el módulo de su submódulo. */
const codigoDe = (a: any, sub: any, moduleId: string): string => a?.code || armarCodigo(sub?.moduleId || moduleId, sub?.id, a?.id);

/** Lo que la matriz muestra (cada acción, marcada o no): el núcleo sólo cambia eso al guardar (RBAC-03). */
export const visiblesDeMatriz = (matriz: any[]): string[] => {
  const codes = new Set<string>();
  for (const entry of matriz || []) {
    for (const sub of entry.submodules || []) for (const a of sub.actions || []) codes.add(codigoDe(a, sub, entry.module?.id));
    for (const sec of entry.sections || []) {
      for (const sub of sec.submodules || []) for (const a of sub.actions || []) codes.add(codigoDe(a, sub, sec.moduleId));
    }
  }
  return [...codes];
};
